export const GET_TASK_SUCCESS = "GET_TASK_SUCCESS"
export const GET_TASK_FAILURE = "GET_TASK_FAILURE"
export const GET_TASK_REQ = "GET_TASK_REQ"

export const POST_TASK_SUCCESS = "POST_TASK_SUCCESS"
export const POST_TASK_FAILURE = "POST_TASK_FAILURE"
export const POST_TASK_REQ = "POST_TASK_REQ"


export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS"
export const DELETE_TASK_FAILURE = "DELETE_TASK_FAILURE"
export const DELETE_TASK_REQ = "DELETE_TASK_REQ"